import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UrlConstantsService } from './url-constants.service';

export interface IUser {
  id: number;
  uuid: string;
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  username: string;
  organization_name: string;
  organization_id: number;
  organization_uuid: string;
}

export interface IOrganization {
  id?: number;
  uuid?: string;
  company_name?: string;
  first_name: string;
  last_name: string;
  email: string;
  phone?: string;
  address?: string;
  zip?: string;
  location?: string;
  country?: string;
}

@Injectable({ providedIn: 'root' })
export class UserManagementService {

  constructor(private http: HttpClient, private urls: UrlConstantsService) {}

  getMe(): Observable<IUser> {
    return this.http.get<IUser>(this.urls.OWN_USER);
  }

  updateMe(data: Partial<IUser>): Observable<IUser> {
    return this.http.patch<IUser>(this.urls.OWN_USER, data);
  }

  changePassword(currentPassword: string, newPassword: string): Observable<{ status: string }> {
    return this.http.post<{ status: string }>(this.urls.OWN_USER_PASSWORD, {
      current_password: currentPassword,
      new_password: newPassword,
    });
  }

  getOrganization(): Observable<IOrganization> {
    return this.http.get<IOrganization>(this.urls.OWN_ORGANIZATION);
  }

  updateOrganization(data: Partial<IOrganization>): Observable<IOrganization> {
    return this.http.patch<IOrganization>(this.urls.OWN_ORGANIZATION, data);
  }
}
